module.exports = __webpack_public_path__ + "img/PCIDSS@2x.9fd17005.png";